<app-generic-container>
    <!-- Usamos el panel genérico -->
    <app-generic-panel [title]="panelTitle" [description]="" [awesomeIcon]="panelIcon">
        <form class="form-horizontal" (ngSubmit)="onSubmit(formEmpleado)"
        #formEmpleado="ngForm" novalidate>

        <app-company-selector dataSize="7" placeHolder="Empresa" [(ngModel)]="selectedCompany" name="selectedCompany"
            [onlyConfigured]="true" [required]="true" (ngModelChange)="onCompanyChange($event)" [gestionEmpleados]="true">
        </app-company-selector>

        <div class="row">

            <div class="col-sm-12 col-lg-4">
                <legend>Trabajador</legend>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                      <input matInput type="number" name="trabajadorCodInicial" placeholder="Código inicial" [(ngModel)]="trabajadorCodInicial" required />
                      </mat-form-field>
                  </div>
                </div>
               <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                        <input matInput type="number" name="trabajadorCodFinal" placeholder="Código final" [(ngModel)]="trabajadorCodFinal" required />
                      </mat-form-field>
                  </div>
                </div>
            </div>

            <!-- <div class="col-sm-12 col-lg-4">
              <legend>Trabajador Comité</legend>
              <div class="row">
                <div class="col-12">
                  <mat-form-field>
                    <input matInput type="number" name="comiteCodInicial" placeholder="Código inicial" [(ngModel)]="comiteCodInicial" required />
                    </mat-form-field>
                </div>
              </div>
             <div class="row">
                <div class="col-12">
                  <mat-form-field>
                      <input matInput type="number" name="comiteCodFinal" placeholder="Código final" [(ngModel)]="comiteCodFinal" required/>
                    </mat-form-field>
                </div>
              </div>
          </div> -->

            <div class="col-sm-12 col-lg-4">
                <legend>Profesional</legend>
                <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                      <input matInput type="number" name="profesionalCodInicial" placeholder="Código inicial" [(ngModel)]="profesionalCodInicial" required />
                      </mat-form-field>
                  </div>
                </div>
               <div class="row">
                  <div class="col-12">
                    <mat-form-field>
                        <input matInput type="number" name="profesionalCodFinal" placeholder="Código final" [(ngModel)]="profesionalCodFinal" />
                      </mat-form-field>
                  </div>
                </div>
            </div>
        </div>

        <!-- Botonera -->
        <div class="row">
            <label class="col-md-3"></label>
            <div class="col-md-9">
            <div class="form-group form-button">
                <button class="btn btn-fill btn-primary float-right" type="submit"
                [disabled]="!formEmpleado.valid || loading">Guardar</button>
                <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
            </div>
            </div>
        </div>
      </form>
    </app-generic-panel>
  </app-generic-container>
